var _path, _path2, _path3, _path4, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifiSponsor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 104,
    viewBox: "0 0 102 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9992 28.5L79.4152 25.0001L79.9335 31.5344L83.864 72.4956C63.2845 76.3052 44.5597 75.8866 24.7803 78.0298C21.8922 64.4934 20.6402 50.6515 20.3829 37.0001C20.3481 35.1543 20.3315 32.3304 20.3315 30.5344C25.7246 29.9477 38.9992 28.5 38.9992 28.5Z",
    fill: "#FFB52E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3829 37.0001C20.3481 35.1543 20.3315 32.3304 20.3315 30.5344C25.7246 29.9477 38.9992 28.5 38.9992 28.5L79.4152 25.0001L79.9335 31.5344M20.3829 37.0001C20.6402 50.6515 21.8922 64.4934 24.7803 78.0298C44.5597 75.8866 63.2845 76.3052 83.864 72.4956L79.9335 31.5344M20.3829 37.0001C45.0007 34.0001 56.5007 31.5344 79.9335 31.5344",
    stroke: "#0B0A0B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 62.5002C44 61.0002 46 59.1002 49 58.5002C52 57.9002 54.5 59.5002 55.5 60.5002L51 66.0002L43 62.5002Z",
    fill: "#0D0D0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 57.5002C32.6667 54.0002 39.2 46.6002 48 45.0002C56.8 43.4002 64.6667 48.0002 67.5 50.5002M37 60.5002C39 57.5002 42 53.5002 48 52.5002C54 51.5002 58.5 54.0002 61.5 56.0002M43 62.5002C44 61.0002 46 59.1002 49 58.5002C52 57.9002 54.5 59.5002 55.5 60.5002L51 66.0002L43 62.5002Z",
    stroke: "#0B0A0B",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.7087,
    cy: 33.7413,
    r: 1.5,
    transform: "rotate(-10.1068 23.7087 33.7413)",
    fill: "#0B0A0B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9392,
    cy: 33.11,
    r: 1.5,
    transform: "rotate(-10.1068 27.9392 33.11)",
    fill: "#0B0A0B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.1716,
    cy: 32.4791,
    r: 1.5,
    transform: "rotate(-10.1068 32.1716 32.4791)",
    fill: "#0B0A0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiSponsor);
export default __webpack_public_path__ + "static/media/wifi-sponsor.6149cde0ff6cdd49fe44d5b97bdd2c82.svg";
export { ForwardRef as ReactComponent };